import autobind from 'core-decorators/lib/autobind';
import { Player } from 'video-player-react';

import DataComponent from 'shared/data-components/_data-component';

const { UI_EVENTS, VIDEO_EVENTS } = Player;


export default class PlayerAPIFacade extends DataComponent {
  constructor(props) {
    super(props);

    this.state = {
      isVideoEnded: false,
      isVideoPaused: true,
      isMouseOnPlayer: false,
      isPlayerInFullScreen: false,
    };

    this.bindEvents();
  }

  componentWillUnmount() {
    this.unbindEvents();
  }

  bindEvents() {
    const { eventEmitter } = this.props;

    eventEmitter.on(UI_EVENTS.CONTROL_BLOCK_SHOW_TRIGGERED, this.setShowControlsState);
    eventEmitter.on(UI_EVENTS.CONTROL_BLOCK_HIDE_TRIGGERED, this.setHideControlsState);

    eventEmitter.on(VIDEO_EVENTS.PLAYBACK_STATUS_CHANGED, this.setPlaybackStatusState);

    eventEmitter.on(UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.setFullScreenState);
  }

  unbindEvents() {
    const { eventEmitter } = this.props;

    eventEmitter.off(UI_EVENTS.CONTROL_BLOCK_SHOW_TRIGGERED, this.setShowControlsState);
    eventEmitter.off(UI_EVENTS.CONTROL_BLOCK_HIDE_TRIGGERED, this.setHideControlsState);

    eventEmitter.off(VIDEO_EVENTS.PLAYBACK_STATUS_CHANGED, this.setPlaybackStatusState);

    eventEmitter.off(UI_EVENTS.FULLSCREEN_STATUS_CHANGED, this.setFullScreenState);
  }

  @autobind
  setPlaybackStatusState(playbackStatus) {
    const { engine: { STATUSES } } = this.props;
    this.setState({
      isVideoEnded: playbackStatus === STATUSES.ENDED,
      isVideoPaused: playbackStatus === STATUSES.PAUSED,
    });
  }

  @autobind
  setShowControlsState() {
    this.setState({
      isControlsShown: true,
    });
  }

  @autobind
  setHideControlsState() {
    this.setState({
      isControlsShown: false,
    });
  }

  @autobind
  setFullScreenState(isInFullScreen) {
    this.setState({
      isPlayerInFullScreen: isInFullScreen,
    });
  }

  @autobind
  exitFullScreen() {
    const { eventEmitter } = this.props;

    eventEmitter.emit(UI_EVENTS.FULLSCREEN_EXIT_TRIGGERED);
  }

  @autobind
  pauseVideo() {
    const { engine } = this.props;

    engine.pause();
  }

  get childProps() {
    return {
      ...this.state,
      pauseVideo: this.pauseVideo,
      exitFullScreen: this.exitFullScreen,
    };
  }
}




// WEBPACK FOOTER //
// ./src/widget/player-widget/components/new-player/components/player-api-facade.js